import { render } from "./MpfEdit.vue?vue&type=template&id=5a81b657"
import script from "./MpfEdit.vue?vue&type=script&lang=js"
export * from "./MpfEdit.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\everlife-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__